module.exports = __webpack_public_path__ + "img/77.84f539bf.jpg";